import React, { useEffect, useState, useRef } from 'react';
import { useGame } from '../contexts/GameContext';
const Player = () => {
  const {
    addStar,
    updatePlayerPosition
  } = useGame();
  const [position, setPosition] = useState({
    x: 400,
    y: 300
  });
  const [username] = useState('Dev' + Math.floor(Math.random() * 1000));
  const positionRef = useRef({
    x: 400,
    y: 300
  });
  const keysRef = useRef({
    up: false,
    down: false,
    left: false,
    right: false
  });
  const animationFrameRef = useRef(null);
  useEffect(() => {
    const speed = 4;
    const handleKeyDown = e => {
      if (e.key === 'ArrowUp' || e.key === 'w' || e.key === 'W') {
        e.preventDefault();
        keysRef.current.up = true;
      }
      if (e.key === 'ArrowDown' || e.key === 's' || e.key === 'S') {
        e.preventDefault();
        keysRef.current.down = true;
      }
      if (e.key === 'ArrowLeft' || e.key === 'a' || e.key === 'A') {
        e.preventDefault();
        keysRef.current.left = true;
      }
      if (e.key === 'ArrowRight' || e.key === 'd' || e.key === 'D') {
        e.preventDefault();
        keysRef.current.right = true;
      }
    };
    const handleKeyUp = e => {
      if (e.key === 'ArrowUp' || e.key === 'w' || e.key === 'W') {
        keysRef.current.up = false;
      }
      if (e.key === 'ArrowDown' || e.key === 's' || e.key === 'S') {
        keysRef.current.down = false;
      }
      if (e.key === 'ArrowLeft' || e.key === 'a' || e.key === 'A') {
        keysRef.current.left = false;
      }
      if (e.key === 'ArrowRight' || e.key === 'd' || e.key === 'D') {
        keysRef.current.right = false;
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);
    // Animation loop using requestAnimationFrame for smoother movement
    const animate = () => {
      let newX = positionRef.current.x;
      let newY = positionRef.current.y;
      let moved = false;
      if (keysRef.current.up) {
        newY -= speed;
        moved = true;
      }
      if (keysRef.current.down) {
        newY += speed;
        moved = true;
      }
      if (keysRef.current.left) {
        newX -= speed;
        moved = true;
      }
      if (keysRef.current.right) {
        newX += speed;
        moved = true;
      }
      // Diagonal movement normalization for consistent speed
      if ((keysRef.current.up || keysRef.current.down) && (keysRef.current.left || keysRef.current.right)) {
        const diagonal = speed / Math.sqrt(2);
        const dx = newX - positionRef.current.x;
        const dy = newY - positionRef.current.y;
        newX = positionRef.current.x + dx / speed * diagonal;
        newY = positionRef.current.y + dy / speed * diagonal;
      }
      // Boundary check
      newX = Math.max(20, Math.min(window.innerWidth - 320, newX));
      newY = Math.max(20, Math.min(window.innerHeight - 20, newY));
      if (moved && (newX !== positionRef.current.x || newY !== positionRef.current.y)) {
        positionRef.current = {
          x: newX,
          y: newY
        };
        setPosition({
          x: newX,
          y: newY
        });
        // Update player position in context for collision detection
        updatePlayerPosition({
          x: newX,
          y: newY
        });
      }
      animationFrameRef.current = requestAnimationFrame(animate);
    };
    animationFrameRef.current = requestAnimationFrame(animate);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [updatePlayerPosition]);
  return <div className="absolute transition-none" style={{
    left: position.x,
    top: position.y,
    transform: 'translate(-50%, -50%)',
    willChange: 'transform'
  }} data-id="element-142">
      {/* Player circle */}
      <div className="w-10 h-10 rounded-full bg-green-500 shadow-lg" style={{
      boxShadow: '0 0 20px rgba(76, 175, 80, 0.5)'
    }} data-id="element-143" />
      {/* Username */}
      <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 text-white text-sm whitespace-nowrap" data-id="element-144">
        {username}
      </div>
    </div>;
};
export default Player;